const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, pageNumber: 1 });
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  'UnitSelector.HeaderWrapper': ({ isOpen, containerRef, selectedUnitIds, isUnitMultiSelectionAllowed }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;

    if (isUnitMultiSelectionAllowed) {
      internalStateSetter({ isOpen: !isOpen, pageNumber: 1 });
    } else {
      (selectedUnitIds.length < 1) && internalStateSetter({ isOpen: !isOpen, pageNumber: 1 });
    }

    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePropertySelector);
    } else {
      document.addEventListener("mousedown", holder.closePropertySelector);
    }
  },
  'UnitSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SearchInput': ({ value, isUnitMultiSelectionAllowed, selectedUnitIds }, _, internalStateSetter) => {
    if (isUnitMultiSelectionAllowed) {
      internalStateSetter({ searchTerm: value })
    } else {
      (selectedUnitIds.length < 1) && internalStateSetter({ searchTerm: value })
    }

  },
  'UnitSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SearchInput(Keydown)': ({ value, isUnitMultiSelectionAllowed, selectedUnitIds }, _, internalStateSetter) => {
    if (isUnitMultiSelectionAllowed) {
      internalStateSetter({ searchTerm: value })
    } else {
      (selectedUnitIds.length < 1) && internalStateSetter({ searchTerm: value })
    }
  },
  'UnitSelector.Body.Unit': ({ unit, selectedUnitIds }, outlet, internalStateSetter) => {
    outlet({ selectedUnitIds: [...selectedUnitIds, unit.id] })
    internalStateSetter('isOpen', false);
    internalStateSetter('searchTerm', '');
  },
  'UnitSelector.HeaderWrapper.LeftSideWrapper.Wrapper.SelectedButton': ({ selectedUnitIds, id }, outlet) => {
    outlet({ selectedUnitIds: selectedUnitIds.filter(unit => id != unit) });
  },
  'UnitSelector.Body.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
  'UnitSelector.HeaderWrapper.AddUnit': ({ isOpen, isAddUnitButtonExternalFunction, selectedUnitIds }, outlet, internalStateSetter) => {
    if (isAddUnitButtonExternalFunction) {
      outlet({ selectedUnitIds, action: 'add_unit_button' })
    } else {
      internalStateSetter({ isOpen: !isOpen })
    }
  }
}